export default __webpack_public_path__ + "static/rs-cab982607b22f216be9d5ca34c0ea32f.svg";